// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentUploadModal_wrapper__jxdwE","icon":"DocumentUploadModal_icon__c9syg","upload":"DocumentUploadModal_upload__xbMxG","close":"DocumentUploadModal_close__nHBGo"};